export default {
  namespaced: true,
  state: {
    community: {}
  },
  getters: {
    COMMUNITY: state => {
      return state.community
    }
  },
  mutations: {
    SET_COMMUNITY(state, payload) {
      state.community = payload
    }
  },
  actions: {
    setCommunity({ commit }, newValue) {
      commit('SET_COMMUNITY', newValue)
    }
  }
}
